import React from 'react';
import Select from '../../../components/ui/Select';

const PerformanceFilters = ({ filters, onFiltersChange, departments, employees }) => {
  const handleFilterChange = (key, value) => {
    onFiltersChange({
      ...filters,
      [key]: value
    });
  };

  // Get unique managers from employees
  const managers = employees
    ?.filter(emp => emp?.id && employees?.some(e => e?.managerId === emp?.id))
    ?.map(emp => ({
      id: emp?.id,
      name: `${emp?.firstName} ${emp?.lastName}`
    })) || [];

  const reviewPeriods = [
    { value: 'q1_2024', label: 'Q1 2024' },
    { value: 'q2_2024', label: 'Q2 2024' },
    { value: 'q3_2024', label: 'Q3 2024' },
    { value: 'q4_2024', label: 'Q4 2024' },
    { value: 'annual_2024', label: 'Annual 2024' }
  ];

  const performanceRatings = [
    { value: '5', label: 'Exceptional (5.0)' },
    { value: '4', label: 'Exceeds (4.0-4.9)' },
    { value: '3', label: 'Meets (3.0-3.9)' },
    { value: '2', label: 'Below (2.0-2.9)' },
    { value: '1', label: 'Needs Improvement (1.0-1.9)' }
  ];

  const goalStatuses = [
    { value: 'on_track', label: 'On Track' },
    { value: 'at_risk', label: 'At Risk' },
    { value: 'completed', label: 'Completed' },
    { value: 'overdue', label: 'Overdue' }
  ];

  return (
    <div className="space-y-4 mt-4">
      {/* Department Filter */}
      <div>
        <label className="block text-xs font-medium text-gray-700 mb-1">
          Department
        </label>
        <Select
          value={filters?.department || ''}
          onChange={(e) => handleFilterChange('department', e?.target?.value)}
          className="w-full text-sm"
        >
          <option value="">All Departments</option>
          {departments?.map((dept) => (
            <option key={dept?.id} value={dept?.id}>
              {dept?.name}
            </option>
          ))}
        </Select>
      </div>

      {/* Manager Filter */}
      <div>
        <label className="block text-xs font-medium text-gray-700 mb-1">
          Manager
        </label>
        <Select
          value={filters?.manager || ''}
          onChange={(e) => handleFilterChange('manager', e?.target?.value)}
          className="w-full text-sm"
        >
          <option value="">All Managers</option>
          {managers?.map((manager) => (
            <option key={manager?.id} value={manager?.id}>
              {manager?.name}
            </option>
          ))}
        </Select>
      </div>

      {/* Review Period Filter */}
      <div>
        <label className="block text-xs font-medium text-gray-700 mb-1">
          Review Period
        </label>
        <Select
          value={filters?.reviewPeriod || ''}
          onChange={(e) => handleFilterChange('reviewPeriod', e?.target?.value)}
          className="w-full text-sm"
        >
          <option value="">All Periods</option>
          {reviewPeriods?.map((period) => (
            <option key={period?.value} value={period?.value}>
              {period?.label}
            </option>
          ))}
        </Select>
      </div>

      {/* Performance Rating Filter */}
      <div>
        <label className="block text-xs font-medium text-gray-700 mb-1">
          Performance Rating
        </label>
        <Select
          value={filters?.performanceRating || ''}
          onChange={(e) => handleFilterChange('performanceRating', e?.target?.value)}
          className="w-full text-sm"
        >
          <option value="">All Ratings</option>
          {performanceRatings?.map((rating) => (
            <option key={rating?.value} value={rating?.value}>
              {rating?.label}
            </option>
          ))}
        </Select>
      </div>

      {/* Goal Status Filter */}
      <div>
        <label className="block text-xs font-medium text-gray-700 mb-1">
          Goal Status
        </label>
        <Select
          value={filters?.goalStatus || ''}
          onChange={(e) => handleFilterChange('goalStatus', e?.target?.value)}
          className="w-full text-sm"
        >
          <option value="">All Goals</option>
          {goalStatuses?.map((status) => (
            <option key={status?.value} value={status?.value}>
              {status?.label}
            </option>
          ))}
        </Select>
      </div>

      {/* Clear Filters */}
      {(filters?.department || filters?.manager || filters?.reviewPeriod || filters?.performanceRating || filters?.goalStatus) && (
        <button
          onClick={() => onFiltersChange({
            department: '',
            manager: '',
            reviewPeriod: '',
            performanceRating: '',
            goalStatus: ''
          })}
          className="w-full text-xs text-blue-600 hover:text-blue-800 font-medium py-2"
        >
          Clear All Filters
        </button>
      )}
    </div>
  );
};

export default PerformanceFilters;